module.exports = __webpack_public_path__ + "fonts/athletes-ic.svg";